import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useAuth } from "../context/ApiKeyContext";
import { getApiBaseUrl } from "../config";
import {
  EMBED_KEY_HEADER,
  buildEmbedDestination,
  persistEmbedSession,
} from "../constants/embedMode";

const API_BASE_URL = getApiBaseUrl();

function readEmbedKeyFromLocation() {
  const params = new URLSearchParams(window.location.search);
  return params.get("key") || params.get("embed_key") || "";
}

const EmbedBootstrapPage = ({ onAuthenticated }) => {
  const history = useHistory();
  const { saveAuthData, changeCell } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const bootstrap = async () => {
      const embedKey = readEmbedKeyFromLocation();
      if (!embedKey) {
        setError("Chave de embed ausente. Informe ?key=<chave> na URL.");
        return;
      }

      try {
        const response = await fetch(`${API_BASE_URL}/embed/bootstrap`, {
          method: "POST",
          headers: {
            [EMBED_KEY_HEADER]: embedKey,
          },
        });

        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(data.detail || "Falha ao validar chave de embed");
        }

        if (cancelled) return;

        const userData = {
          user_id: data.user_id,
          name: data.name,
          email: data.email,
          permissions: data.permissions || [],
          product_permissions: data.product_permissions || [],
          cells: data.cells || [],
          company_name: data.company_name,
          tenant_name: data.tenant_name,
          tenant_id: data.tenant_id,
        };

        saveAuthData(data.token, userData);
        persistEmbedSession({
          listingQuery: data.listing_query || {},
          listMode: data.list_mode || "all",
          cellId: data.cell_id ?? null,
        });

        if (data.cell_id != null && userData.cells?.length) {
          const targetCell = userData.cells.find(
            (c) => (c.id || c.value) === data.cell_id,
          );
          if (targetCell) {
            changeCell({
              title: targetCell.name || targetCell.title,
              value: targetCell.id || targetCell.value,
            });
          }
        }

        if (onAuthenticated) {
          onAuthenticated();
        }

        const destination = buildEmbedDestination(data.to || "/contestacoes");
        history.replace(destination);
      } catch (err) {
        if (!cancelled) {
          setError(err.message || "Erro ao iniciar sessão embed");
        }
      }
    };

    bootstrap();

    return () => {
      cancelled = true;
    };
  }, [history, onAuthenticated, saveAuthData, changeCell]);

  if (error) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        padding={3}
      >
        <Typography variant="h6" color="error" gutterBottom>
          Não foi possível abrir o embed
        </Typography>
        <Typography variant="body2" color="textSecondary" align="center">
          {error}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
    >
      <CircularProgress />
      <Typography variant="body2" style={{ marginTop: 16 }}>
        Validando acesso...
      </Typography>
    </Box>
  );
};

export default EmbedBootstrapPage;
